function getFirstImage(obj, format = 'UrlLarge') {
	return obj.media?.find((el) => { return el.isImage })?.urlFullHD
}

export { getFirstImage };
